'use client';

import { useAllMarketInterestData } from './useAllMarketInterestData';
import { MarketInterestData } from './types';

export interface UseMarketInterestDataParams {
	marketIndex: number | undefined;
}

export function useMarketInterestData({
	marketIndex,
}: UseMarketInterestDataParams): MarketInterestData | undefined {
	const { data: allMarketData } = useAllMarketInterestData();
	return marketIndex != undefined && allMarketData
		? allMarketData[marketIndex]
		: undefined;
}
